import { useLocale } from "../../i18n/LocaleProvider";

import styles from "./LanguageSwitcher.module.css";

export function LanguageSwitcher() {
  const { locale, setLocale, copy } = useLocale();

  return (
    <div
      className={styles.switcher}
      role="group"
      aria-label={copy.localeSwitcher.aria}
    >
      <button
        type="button"
        className={`${styles.btn} ${locale === "ru" ? styles.active : ""}`}
        aria-pressed={locale === "ru"}
        onClick={() => {
          setLocale("ru");
        }}
      >
        {copy.localeSwitcher.ru}
      </button>
      <button
        type="button"
        className={`${styles.btn} ${locale === "en" ? styles.active : ""}`}
        aria-pressed={locale === "en"}
        onClick={() => {
          setLocale("en");
        }}
      >
        {copy.localeSwitcher.en}
      </button>
    </div>
  );
}
